<searchbar [loggedInUser]="loggedInUser$ | async"></searchbar>
